import { Component } from '@angular/core';

@Component({
  selector: 'app-form-stations',
  templateUrl: './form-stations.component.html',
  styleUrls: ['./form-stations.component.scss']
})
export class FormStationsComponent {

}
